import { hashHistory } from './hashHistory';

let preventRedirect: boolean | null = null;

const mergeSearch = (currentSearch: string, nextSearch: string) => {
  const params = new URLSearchParams(currentSearch);

  new URLSearchParams(nextSearch).forEach((value, key) => {
    params.set(key, value);
  });

  const search = params.toString();
  return search ? `?${search}` : '';
};

export const redirectTo = (url, skip = false, clientId = '') => {
  // Always use plugin mode (hash-based routing)
  const location = hashHistory.getCurrentLocation();
  const search = mergeSearch(location.search, clientId);
  const nextLocation = {
    ...location,
    pathname: url,
    search,
  };

  if (preventRedirect) {
    hashHistory.replace(nextLocation);
  }
  else {
    hashHistory.push(nextLocation)
  }
  preventRedirect = skip;
}
